module.exports = __webpack_public_path__ + "static/media/office_7.90e24a55.jpg";